import {
    HttpGetProjectClinicalPresentationsResponse,
    httpGetProjectClinicalPresentations
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface UseGetProjectClinicalPresentationsOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<
        UseQueryOptions<HttpGetProjectClinicalPresentationsResponse, AxiosError<ErrorResponseData>>,
        'queryKey' | 'queryFn'
    >
}

export const useGetProjectClinicalPresentations = ({urlParams, options}: UseGetProjectClinicalPresentationsOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECT_CLINICAL_PRESENTATIONS, urlParams.projectId],
        queryFn: () => httpGetProjectClinicalPresentations({urlParams}),
        ...options
    })
